import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'a1-input',
  styleUrl: 'a1-input.scss',
  scoped: true,
})
export class A1Input {
  @State() private showPassword = false;
  // amazonq-ignore-next-line // false alarm
  @State() private passwordIcon = 'icon-password-show';
  @State() private hasFocus = false;

  /**
   * Field ID.
   */
  @Prop({ reflect: true }) inputId: string = '';

  /**
   * Field label.
   */
  @Prop({ reflect: true }) label: string = '';

  /**
   * Input value.
   */
  @Prop({ reflect: true }) value: string = '';

  /**
   * Content prepended to input.
   */
  @Prop({ reflect: true }) inputPrefix: string = '';

  /**
   * Content appended to input.
   */
  @Prop({ reflect: true }) inputPostfix: string = '';

  /**
   * Placeholder text to show as a hint when the input is empty.
   */
  @Prop({ reflect: true }) placeholder: string = '';

  /**
   * Input type.
   */
  @Prop({ reflect: true }) type: 'text' | 'number' | 'password' = 'text';

  /**
   * Toggle for enabling / disabling input.
   */
  @Prop({ reflect: true }) disabled: boolean = false;

  /**
   * Toggle for regular / critical input appearance.
   */
  @Prop({ reflect: true }) critical: boolean = false;

  /**
   * Makes the input readonly.
   */
  @Prop({ reflect: true }) readonly: boolean = false;

  private _revealPass = (e: Event) => {
    if (!this.showPassword) {
      this.type = 'text';
      // amazonq-ignore-next-line // false alarm
      this.passwordIcon = 'icon-password-hide';
    } else {
      this.type = 'password';
      // amazonq-ignore-next-line // false alarm
      this.passwordIcon = 'icon-password-show';
    }
    this.showPassword = !this.showPassword;

    e.preventDefault();
  };

  private handleBlur = () => {
    this.hasFocus = false;
  };

  private handleFocus = () => {
    this.hasFocus = true;
  };

  render() {
    const classes: Record<string, boolean> = {
      'input-critical': this.critical,
      'input-disabled': this.disabled,
      'input-readonly': this.readonly,
      'input-focused': this.hasFocus,
    };

    return (
      <div class="input-wrapper">
        {this.label && <a1-label class="input-label" text={this.label} forInput={this.inputId}></a1-label>}
        <div
          class={`input-body ${Object.keys(classes)
            .filter(key => classes[key])
            .join(' ')}`}
          tabindex={this.disabled ? -1 : undefined}
        >
          {this.inputPrefix ? <span class="input-prefix">{this.inputPrefix}</span> : null}
          <input
            id={this.inputId}
            type={this.type}
            placeholder={this.placeholder}
            disabled={this.disabled}
            readonly={this.readonly}
            value={this.value}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
          {this.inputPostfix ? <span class="input-postfix">{this.inputPostfix}</span> : null}
          {this.type === 'password' || this.showPassword ? (
            <span class={`icon ${this.passwordIcon}`} onClick={this._revealPass} aria-hidden="true"></span>
          ) : null}
        </div>
      </div>
    );
  }
}
